import { render, staticRenderFns } from "./DaKudoForm.vue?vue&type=template&id=2b35ac1a&scoped=true&"
import script from "./DaKudoForm.vue?vue&type=script&lang=js&"
export * from "./DaKudoForm.vue?vue&type=script&lang=js&"
import style0 from "./DaKudoForm.vue?vue&type=style&index=0&id=2b35ac1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35ac1a",
  null
  
)

export default component.exports